import React from 'react'
import { Link } from "react-router-dom"

const Links = ({target, content, ariaLabel}) => {
    return (
        <Link to={`${target}`} aria-label={ariaLabel}>{content}</Link>
    )
}

export default Links